export default {
    // --------Title--------
    examineInventory: 'Examine Inventory',
    youCanSelectMultipleWarehouseLocationsToProceed: 'You can select multiple warehouse locations to proceed',
    selectProducts: 'Select Products',
    multipleSelectedItemsForExaminationResults: 'Multiple selected items for examination results',
    selectLocations: 'Select Locations',
    scopeTheRangeOfTheSearchLocations: 'Scope the range of the search locations',
    noDataFound: 'No Data Found',
    relocateThresholdControl: 'Relocate Threshold Control',
    reorderThresholdControl: 'Reorder Threshold Control',

    // --------MUI--------
    startQuery: 'Start Query',
    threshold: 'Threshold',
    suggestQty: 'Suggest Qty',


    // ----examine inventory---
    inStockBalance: 'In Stock Balance',
    transferInTransit: 'Transfer in Transit',
    grossBalance: 'Gross Balance',
    pendingInbound: 'Pending Inbound',
    stockTakeStock: 'Stock Take',
    usageStock: 'Usage Qty'
};